module.exports = __webpack_public_path__ + "images/cebsb_logo.1790562670165.png";